var map = {
	"./auditManage.svg": "uECX",
	"./auditMemberReport.svg": "zRXD",
	"./auditPlReport.svg": "04Bw",
	"./auditReport.svg": "/tca",
	"./auditReport1.svg": "rDO0",
	"./auditVideo.svg": "/DUh",
	"./cms-subject.svg": "MYj2",
	"./cms-topic.svg": "Z+Dd",
	"./cms.svg": "r0R6",
	"./config.svg": "GPwb",
	"./dashboard.svg": "94Jb",
	"./dict.svg": "Hro+",
	"./document.svg": "/SjJ",
	"./example.svg": "MMMJ",
	"./eye.svg": "TfVu",
	"./fankui.svg": "9n7y",
	"./feedBack.svg": "0z9a",
	"./feedBackManage.svg": "Wky/",
	"./feedBackType.svg": "5Pmr",
	"./form.svg": "6xvN",
	"./home.svg": "a75Z",
	"./kefu-manage.svg": "uQjN",
	"./kefu.svg": "AGO7",
	"./login-mall.svg": "DeUv",
	"./marker.svg": "7c14",
	"./membeReport.svg": "DH5k",
	"./neirong.svg": "UmSq",
	"./order-return-reason.svg": "c1XP",
	"./order-return.svg": "SAtf",
	"./order-setting.svg": "5LYP",
	"./order.svg": "Ef/C",
	"./password.svg": "Kj24",
	"./product-add.svg": "y8lK",
	"./product-attr.svg": "l0Gx",
	"./product-brand.svg": "YPyR",
	"./product-cate.svg": "V6dm",
	"./product-comment.svg": "YPQu",
	"./product-list.svg": "4vWP",
	"./product-recycle.svg": "W+A4",
	"./product.svg": "jTAa",
	"./shop.svg": "Xe8X",
	"./sms-ad.svg": "hHy6",
	"./sms-coupon.svg": "vvyb",
	"./sms-flash.svg": "4mcA",
	"./sms-hot.svg": "uIj3",
	"./sms-new.svg": "0HLU",
	"./sms-subject.svg": "FyRK",
	"./sms.svg": "aUsG",
	"./statistics.svg": "oc+f",
	"./table.svg": "R/Hx",
	"./total-today.svg": "/aMr",
	"./total-week.svg": "r/m+",
	"./total-yesterday.svg": "jwDv",
	"./tree.svg": "k80C",
	"./ums-admin.svg": "qUXj",
	"./ums-menu.svg": "AR6t",
	"./ums-resource.svg": "oMdP",
	"./ums-role.svg": "MsIV",
	"./ums.svg": "5Bjt",
	"./user.svg": "s7Vf",
	"./version.svg": "jjc4",
	"./video.svg": "jyte",
	"./videoAudit.svg": "I+xH",
	"./withdrawAudit.svg": "toG9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";